import { TextField } from "@mui/material";
import { useContext } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
//
// ################################################################################
//
const ArregloAnteojoCristales = () => {
	const {
		arregloAnteojoCristales,
		handleChangeArregloAnteojoCristales,
		gaAction,
	} = useContext(
		GestionAtencionContext
	);

	const { arregloAnteojoCristalesDescripcion } = arregloAnteojoCristales;

	return (
		<>
			<TextField
				sx={{ width: "100%", mb: 1 }}
				id="observaciones"
				variant="outlined"
				label="Ingresá una descripción del anteojo o de los cristales del Cliente"
				multiline
				maxRows={3}
				name="arregloAnteojoCristalesDescripcion"
				value={arregloAnteojoCristalesDescripcion}
				onChange={handleChangeArregloAnteojoCristales}
				disabled={gaAction.cu === "view"}
			/>
		</>
	);
};
export default ArregloAnteojoCristales;
